import { Link } from 'react-router-dom';
import { getRecentArticles } from '@/mocks/articles';
import { categoryData } from '@/mocks/categories';

export default function FeaturedArticles() {
  const recentArticles = getRecentArticles(6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-[var(--font-heading)]">
            编辑精选推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为您精选优质内容，发现更多精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {recentArticles.map((article) => {
            const cat = categoryData.find((c) => c.id === article.category);
            return (
              <article key={article.id} className="bg-white rounded-xl border border-background-200/70 overflow-hidden group transition-all duration-300 hover:border-primary-200">
                <Link to={`/article/${article.slug}`} className="block no-underline">
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-full">
                        {cat?.name || article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <h3 className="text-base md:text-lg font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-4">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <div className="flex items-center gap-3">
                        <span className="flex items-center gap-1">
                          <i className="ri-calendar-line"></i>
                          {article.date}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line"></i>
                          {article.views.toLocaleString()}
                        </span>
                      </div>
                      <span className="flex items-center gap-1 text-primary-500 font-medium">
                        阅读更多
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              </article>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/zixun"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 no-underline whitespace-nowrap"
          >
            浏览全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}